import { useId } from 'react';

import { Rating } from '../../primitives/Rating';

import { UnknownValue } from './UnknownValue';

interface SummaryRatingFieldProps {
  value: number | null;
  onChange: (value: number | null) => void;
  error: string | undefined;
}

/** The rating input with its current score and a button to clear it. */
export function SummaryRatingField({ value, onChange, error }: SummaryRatingFieldProps) {
  const labelId = useId();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span id={labelId} style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-ink-2)' }}>
        Co-marketing rating
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <Rating value={value} onChange={onChange} size={22} labelledBy={labelId} />
        <span className="nb-tabular" style={{ fontSize: 13, fontWeight: 700, minWidth: 36 }}>
          {value === null ? <UnknownValue>Not rated</UnknownValue> : `${value} / 5`}
        </span>
        {value !== null && (
          <button
            type="button"
            className="nb-btn nb-btn-ghost nb-tap"
            onClick={() => onChange(null)}
            style={{ height: 20, fontSize: 10, padding: '0 6px' }}
          >
            Clear rating
          </button>
        )}
      </div>
      {error && <span style={{ fontSize: 10.5, color: 'var(--nb-risk)' }}>{error}</span>}
    </div>
  );
}
